import axios from 'axios'
import api from './api'
import Vue from 'vue';
let Base64 = require('js-base64').Base64;
import { Toast } from 'vant';
import qs from "qs";
import i18n from '../i18n';

Vue.use(Toast);

function t(key, fallback) {
    try {
        const text = i18n.t(key);
        return text && text !== key ? text : fallback;
    } catch (e) {
        return fallback;
    }
}

//创建axios实例对象 
const  instance = axios.create({
    baseURL: 'https://admin.sex999.club/api', //服务器地址
    timeout: 30000, // 列表接口查询较多，避免5秒超时被误报成网络失败
})

//请求拦截器
instance.interceptors.request.use(config=>{
    if(config.method === "post"){
        config.headers = {
            'content-type': 'application/x-www-form-urlencoded;charset=UTF-8', // 设置跨域头部
        }
    }
    if(localStorage.getItem('token')){
        config.headers = Object.assign({}, config.headers, {
            'token': Base64.encode(localStorage.getItem('token')),
        });
    }
    return config
},err=>{
    // 静默处理请求拦截器错误，避免过多日志
    return Promise.reject(err)
})

//响应拦截器
instance.interceptors.response.use(res=>{
    //此处对响应数据做处理
    if(res && res.data && res.data.msg === "鉴权错误"){
        localStorage.clear();
        // 使用 Vue Router 实例而不是 this
        if (window.location.pathname !== '/Login') {
            window.location.href = '/Login';
        }
    }
    return res //该返回对象会传到请求方法的响应对象中
},err=>{
    // 响应错误处理 - 区分超时 / HTTP状态 / 真断网，文案走多语言
    const status = err.response && err.response.status;
    const isTimeout = err.code === 'ECONNABORTED' || (err.message && err.message.includes('timeout'));
    const isNetworkError = err.code === 'ERR_SSL_PROTOCOL_ERROR' || 
                          err.code === 'ERR_NETWORK' || 
                          err.message === 'Network Error' ||
                          (err.message && err.message.includes('SSL'));

    let message = err.message || t('common.requestFailed', 'リクエストに失敗しました');
    if (isTimeout) {
        message = t('common.requestTimeout', 'リクエストがタイムアウトしました。後でもう一度お試しください');
    } else if (status === 404) {
        message = t('common.apiNotFound', 'APIが見つかりません(404)');
    } else if (status === 500) {
        message = t('common.serverError', 'サーバーエラー(500)');
    } else if (status === 401 || status === 403) {
        message = t('common.loginExpired', 'ログインの有効期限が切れました。再ログインしてください');
    } else if (isNetworkError) {
        message = t('common.networkError', 'ネットワーク接続に失敗しました。設定を確認してください');
    }
    
    const errorObj = {
        code: status || err.code || 'NETWORK_ERROR',
        message: message,
        data: null,
        originalError: err
    };
    
    return Promise.reject(errorObj);
})

//封装axios请求方法，参数为配置对象
//option = {method,url,params} method为请求方法，url为请求接口，params为请求参数
// 判断是否为开发环境
const isDevelopment = process.env.NODE_ENV === 'development';

async function http(option = {}) {
    let result = null
    try {
        if(option.method === 'get' || option.method === 'delete'){
            //处理get、delete请求
            const response = await instance[option.method](
                api[option.url],
                {params: option.data}
            );
            if (response && response.data) {
                result = response.data;
                // 安全解码，避免解码失败
                if (result.data && typeof result.data === 'string') {
                    try {
                        result.data = JSON.parse(Base64.decode(result.data));
                    } catch (decodeErr) {
                        // 只在开发环境输出详细错误
                        if (isDevelopment) {
                            console.warn('数据解码失败:', decodeErr);
                        }
                        result.data = null;
                    }
                }
            }
        }else if(option.method === 'post' || option.method === 'put'){
            //处理post、put请求
            const response = await instance[option.method](
                api[option.url],
                qs.stringify(option.data)
            );
            if (response && response.data) {
                result = response.data;
                // 安全解码，避免解码失败
                if (result.data && typeof result.data === 'string') {
                    try {
                        result.data = JSON.parse(Base64.decode(result.data));
                    } catch (decodeErr) {
                        // 只在开发环境输出详细错误
                        if (isDevelopment) {
                            console.warn('数据解码失败:', decodeErr);
                        }
                        result.data = null;
                    }
                }
            }
        }
    } catch (err) {
        // 统一错误处理 - 减少生产环境的日志输出
        if (isDevelopment) {
            console.warn('HTTP 请求失败:', err.message || err);
        }
        result = {
            error: true,
            code: err.code || 'NETWORK_ERROR',
            message: err.message || t('common.requestFailed', 'リクエストに失敗しました'),
            data: null
        };
    }
    return result
}

export default http


